import { DatePicker, TablePaginationConfig, TimeRangePickerProps } from 'antd';
import type { OptionConfig } from '@ant-design/pro-table/es/components/ToolBar';
import { ProColumns } from '@ant-design/pro-components';
import dayjs from 'dayjs';

//
export const LOGIN_PATH = '/passport/login';
export const DASHBOARD_INDEX = '/dashboard/index';

export const API_PREFIX = '';

export const EMPTY_WAREHOUSE = 'emptyWarehouse';
export const TOP_ORG_ID = '1712654376000265';
export const TOP_ORG = Number(TOP_ORG_ID);

//
export const MIN_DATE = '2020-01-01';

//
export const ACTION_CREATE = 'create';
export const ACTION_EDIT = 'edit';

export const ACTION_SAVE = 'save';
export const ACTION_BATCH_SAVE = 'batchSave';
export const ACTION_GET = 'get';
export const ACTION_BATCH_GET = 'batchGet';

export const ACTION_DETAIL = 'detail';
export const ACTION_LIST = 'list';
export const ACTION_QUERY = 'query';

export const ACTION_ENABLE = 'enable';
export const ACTION_SHOW = 'show';
export const ACTION_DISABLE = 'disable';
export const ACTION_HIDDEN = 'hidden';
export const ACTION_REMOVE = 'remove';
export const ACTION_SET_ORDER = 'setOrder';

export const ACTION_BATCH_ENABLE = 'batchEnable';
export const ACTION_BATCH_SHOW = 'batchShow';
export const ACTION_BATCH_DISABLE = 'batchDisable';
export const ACTION_BATCH_HIDDEN = 'batchHidden';
export const ACTION_BATCH_DELETE = 'batchDelete';
export const ACTION_BATCH_SET_ORDER = 'batchSetOrder';
//
export const PERMISSION_CREATE = ACTION_CREATE;
export const PERMISSION_EDIT = ACTION_EDIT;

export const PERMISSION_SAVE = ACTION_SAVE;
export const PERMISSION_BATCH_SAVE = ACTION_BATCH_SAVE;
export const PERMISSION_GET = ACTION_GET;
export const PERMISSION_BATCH_GET = ACTION_BATCH_GET;

export const PERMISSION_DETAIL = ACTION_DETAIL;
export const PERMISSION_LIST = ACTION_LIST;
export const PERMISSION_QUERY = ACTION_QUERY;

export const PERMISSION_ENABLE = ACTION_ENABLE;
export const PERMISSION_SHOW = ACTION_SHOW;
export const PERMISSION_DISABLE = ACTION_DISABLE;
export const PERMISSION_HIDDEN = ACTION_HIDDEN;
export const PERMISSION_REMOVE = ACTION_REMOVE;
export const PERMISSION_SET_ORDER = ACTION_SET_ORDER;

export const PERMISSION_BATCH_ENABLE = ACTION_BATCH_ENABLE;
export const PERMISSION_BATCH_SHOW = ACTION_BATCH_SHOW;
export const PERMISSION_BATCH_DISABLE = ACTION_BATCH_DISABLE;
export const PERMISSION_BATCH_HIDDEN = ACTION_BATCH_HIDDEN;
export const PERMISSION_BATCH_DELETE = ACTION_BATCH_DELETE;
export const PERMISSION_BATCH_SET_ORDER = ACTION_BATCH_SET_ORDER;

//
export const DATA_ENABLESTATUS_COLUMN = 'enableStatus';
export const DATA_SHOWSTATUS_COLUMN = 'showStatus';
export const DATA_ORDERSORT_COLUMN = 'orderSort';

//

export const DEFAULT_LIST_SCROLL = {
  y: 'max-content',
  x: 'max-content',
};

// scroll={{ y: 55 * 5, x: 'max-content' }}
export const DEFAULT_SELECTOR_SCROLL = { y: 600 };
export const DEFAULT_LIST_PAGINATION: false | TablePaginationConfig = {
  defaultPageSize: 10,
  pageSizeOptions: [5, 10, 20, 50, 100],
  showSizeChanger: true,
};
export const DEFAULT_TABLE_OPTIONS: OptionConfig = {
  fullScreen: true,
  reload: true,
  // search: true,
  search: {
    name: 'keywords',
  },
  setting: {
    listsHeight: 400,
  },
};

export const ImageFileTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/vnd.microsoft.icon',
  'image/png',
  'image/gif',
  'image/webp',
  'application/ico',
];

export const ZipFileTypes = [
  'application/x-bzip',
  'application/x-bzip2',
  'application/gzip',
  'application/vnd.rar',
  'application/x-tar',
  'application/zip',
  'application/x-7z-compressed',
];

export const ExcelFileTypes = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const DocFileTypes = [
  'text/csv',
  'application/csv',
  'application/msword',
  'application/pdf',
  'application/acrobat',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const VideoFileTypes = [
  'video/x-msvideo',
  'video/mpeg',
  'video/mp4',
  'video/mpeg',
  'video/mpeg',
  'video/mp4',
  'video/ogg',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
];

export const AudioFileTypes = [
  'audio/aac',
  'audio/midi',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
  'audio/3gpp',
  'audio/3gpp2',
];

export const AllFileTypes = [
  ...ImageFileTypes,
  ...ZipFileTypes,
  ...DocFileTypes,
  ...VideoFileTypes,
  ...AudioFileTypes,
];

export const enableStatusColumn: ProColumns = {
  title: '启用状态',
  dataIndex: 'enableStatus',
  width: 120,
  filters: true,
  valueType: 'select',
  hideInSearch: true,
  valueEnum: {
    disable: {
      text: '禁用',
      status: 'Error',
    },
    enable: {
      text: '启用',
      status: 'Success',
      disabled: true,
    },
    none: {
      text: '-',
      status: 'Default',
    },
  },
};

export const showStatusColumn: ProColumns = {
  title: '显示状态',
  dataIndex: 'showStatus',
  width: 130,
  filters: true,
  // sorter: true,
  valueType: 'select',
  hideInSearch: true,
  valueEnum: {
    hidden: {
      text: '隐藏',
      status: 'Error',
    },
    show: {
      text: '显示',
      status: 'Success',
      disabled: true,
    },
    none: {
      text: '-',
      status: 'Default',
    },
  },
};

export const orderSortColumn: ProColumns = {
  title: '排序权重',
  width: 100,
  dataIndex: 'orderSort',
  sorter: true,
  hideInSearch: true,
};

export const createdAtColumn: ProColumns = {
  title: '创建时间',
  width: 180,
  dataIndex: 'createdAt',
  valueType: 'text',
  sorter: true,
  copyable: true,
  ellipsis: true,
  hideInSearch: true,
  editable: false,
  renderText: (text, record) => {
    if (text != '') {
      return dayjs(text).format('YYYY-MM-DD HH:mm');
    }
    return text;
  },
};

export const updatedAtColumn: ProColumns = {
  title: '更新时间',
  width: 180,
  dataIndex: 'updatedAt',
  valueType: 'text',
  sorter: true,
  copyable: true,
  ellipsis: true,
  hideInSearch: true,
  editable: false,
  renderText: (text, record) => {
    if (text != '') {
      return dayjs(text).format('YYYY-MM-DD HH:mm');
    }
    return text;
  },
};

export const createdDateColumn: ProColumns = {
  title: '创建时间',
  dataIndex: 'createdDate',
  valueType: 'dateRange',
  hideInTable: true,
  editable: false,
  renderFormItem: (schema, { type, value, defaultRender, ...rest }, form) => {
    return (
      <DatePicker.RangePicker
        presets={rangeDatePresets}
        maxDate={dayjs()}
        getPopupContainer={() => {
          return document.body;
        }}
      />
    );
  },
};

export const updatedDateColumn: ProColumns = {
  title: '更新时间',
  dataIndex: 'updatedDate',
  valueType: 'dateRange',
  hideInTable: true,
  editable: false,
  renderFormItem: (schema, { type, value, defaultRender, ...rest }, form) => {
    return (
      <DatePicker.RangePicker
        presets={rangeDatePresets}
        maxDate={dayjs()}
        getPopupContainer={() => {
          return document.body;
        }}
      />
    );
  },
};

// export const warehouseIdColumn = (): ProColumns => {
//   return {
//     title: '仓房',
//     dataIndex: 'warehouseId',
//     hideInTable: true,
//     editable: false,
//     renderFormItem: (schema, { type, value, defaultRender, ...rest }, form) => {
//       return <WarehouseSelector />;
//     },
//   };
// };

export const dateColumnList: ProColumns[] = [
  createdAtColumn,
  updatedAtColumn,
  createdDateColumn,
  updatedDateColumn,
];

export const rangeDatePresets: TimeRangePickerProps['presets'] = [
  { label: '过去 1 天', value: [dayjs().subtract(1, 'd'), dayjs()] },
  { label: '过去 1 周', value: [dayjs().subtract(1, 'w'), dayjs()] },
  { label: '过去 2 周', value: [dayjs().subtract(2, 'w'), dayjs()] },
  { label: '过去 1 月', value: [dayjs().subtract(1, 'M'), dayjs()] },
  { label: '过去 2 月', value: [dayjs().subtract(2, 'M'), dayjs()] },
  // @ts-ignore
  { label: '本季度', value: [dayjs().startOf('quarter'), dayjs()] },
  {
    label: '过去 1 季度',
    // @ts-ignore
    value: [dayjs().subtract(1, 'Q').startOf('quarter'), dayjs().subtract(1, 'Q').endOf('quarter')],
  },
  { label: '过去 半年', value: [dayjs().subtract(6, 'M'), dayjs()] },
  { label: '过去 1 年', value: [dayjs().subtract(1, 'y'), dayjs()] },
];

export const datePresets: TimeRangePickerProps['presets'] = [
  { label: '过去 1 周', value: [dayjs().add(-1, 'w'), dayjs()] },
  { label: '过去 2 周', value: [dayjs().add(-2, 'w'), dayjs()] },
  { label: '过去 1 月', value: [dayjs().add(-1, 'M'), dayjs()] },
  { label: '过去 2 月', value: [dayjs().add(-2, 'M'), dayjs()] },
  { label: '过去 1 季度', value: [dayjs().add(-3, 'M'), dayjs()] },
  { label: '过去 2 季度', value: [dayjs().add(-6, 'M'), dayjs()] },
  { label: '过去 1 年', value: [dayjs().add(-1, 'y'), dayjs()] },
  { label: '过去 2 年', value: [dayjs().add(-2, 'y'), dayjs()] },
  { label: '过去 3 年', value: [dayjs().add(-3, 'y'), dayjs()] },
];

export const dateTimeFuturePresets: TimeRangePickerProps['presets'] = [
  {
    label: '今天',
    value: [
      dayjs(dayjs().format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().format('YYYY-MM-DD 14:00:00')),
    ],
  },
  {
    label: '明天',
    value: [
      dayjs(dayjs().add(1, 'd').format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().add(1, 'd').format('YYYY-MM-DD 14:00:00')),
    ],
  },
  {
    label: '后天',
    value: [
      dayjs(dayjs().add(2, 'd').format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().add(2, 'd').format('YYYY-MM-DD 14:00:00')),
    ],
  },
  {
    label: '1周后',
    value: [
      // .startOf('w').add(1, 'd')
      dayjs(dayjs().add(1, 'w').format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().add(1, 'w').format('YYYY-MM-DD 14:00:00')),
    ],
  },
  {
    label: '2周后',
    value: [
      dayjs(dayjs().add(2, 'w').format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().add(2, 'w').format('YYYY-MM-DD 14:00:00')),
    ],
  },
  {
    label: '1月后',
    value: [
      // .startOf('M')
      dayjs(dayjs().add(1, 'M').format('YYYY-MM-DD 12:00:00')),
      dayjs(dayjs().add(1, 'M').format('YYYY-MM-DD 14:00:00')),
    ],
  },
];

export const ROLE_TYPE_PREFIX = 'RT::';
export const ROLE_TYPE_DEVELOP = 'develop';
export const ROLE_TYPE_PROJECT = 'project';
export const ROLE_TYPE_TEST = 'test';
export const ROLE_TYPE_USER = 'user';

export const ROUTE_DICT_SCENES = {
  dynamic: 'dynamicCost',
};

export const DICT_STATUS_TYPES: string[] = ['dynamicCost'];

export const DICT_ACTION_TYPES: string[] = ['dynamicCostLabor'];

export const EXAMINE_COST_ITEM_TYPE = {
  electricity: '电费',
  labor: '用工费用',
  pest: '害虫防治费用',
  expendable: '低值易耗品费用',
  consumable: '耗材费用',
  other: '其他费用',
};

export const EXAMINE_COST_DICT_CODES = {
  electricity: 'costElectricity',
  labor: 'costLabor',
  pest: 'costPest',
  expendable: 'costExpendable',
  consumable: 'costConsumable',
  other: 'costOther',
};

export const EXAMINE_ITEM_TYPE = {
  quantity: '包数量',
  quality: '包质量',
  management: '包管理',
  security: '包安全',
  cost: '包费用',
  honest: '包廉洁',
  other: '其他',
};

export const EXAMINE_ITEM_DICT_CODES = {
  quantity: 'examineQuantity',
  quality: 'examineQuality',
  management: 'examineManagement',
  security: 'examineSecurity',
  cost: 'examineCost',
  honest: 'examineHonest',
  other: 'examineOther',
};

export const DAY_START_FORMAT = 'YYYY-MM-DD 00:00:00';
export const DAY_END_FORMAT = 'YYYY-MM-DD 23:59:59';

export const STORAGE_ITEM_TYPES = {
  average: '入库加权平均结果',
  tentative: '入库初验结果',
  result: '正式验收结果',
};

export const DELIVERY_ITEM_TYPES = {
  result: '出库质量记录',
};

export const PRESERVE_ITEM_TYPES = {
  preserve: '质量检测记录',
};

export const EXAMINE_DATA_SEASON = {
  spring: '春季普查',
  // summer: '夏季普查',
  autumn: '秋季普查',
  // winter: '冬季普查',
};

export const HAS_ORG_CHILD_TYPES = ['child', 'warehouse'];
